import React, { useLayoutEffect, useContext, useRef, useState } from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Brand from '../Brand/Brand';
import Navigation, { NavigationLine } from '../Navigation/Navigation';
import User from '../User/User';
import { componentsMenu, dashboardMenu, demoPages } from '../../menu';
import ThemeContext from '../../contexts/themeContext';
import Card, { CardBody } from '../../components/bootstrap/Card';

import Hand from '../../assets/img/hand.png';
import HandWebp from '../../assets/img/hand.webp';
import Icon from '../../components/icon/Icon';
import Button from '../../components/bootstrap/Button';
import Tooltips from '../../components/bootstrap/Tooltips';
import useDarkMode from '../../hooks/useDarkMode';
import useAsideTouch from '../../hooks/useAsideTouch';
import { userAuth } from '../../contexts/userContext';

const admindata = demoPages['Manage_sadmin'];
const admincontroll = (pagers = {}, isadmin) => {
	const temppage = { ...pagers };

	if (isadmin) {
		return temppage;
	} else {
		delete temppage['Manage_sadmin'];
		return temppage;
	}
};

const Aside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const { asideStyle, touchStatus, hasTouchButton, asideWidthWithSpace, x } = useAsideTouch();
	const isModernDesign = process.env.REACT_APP_MODERN_DESGIN === 'true';
	const constraintsRef = useRef(null);
	const [doc, setDoc] = useState(false);
	const { darkModeStatus } = useDarkMode();
	const startX = useRef(null);
	const endX = useRef(null);
	const deviceWidth = window.innerWidth;
	const { token, setToken } = useContext(userAuth);

	useLayoutEffect(() => {
		function handleTouchStart(e) {
			startX.current = e.touches[0].clientX;
		}

		function handleTouchEnd(e) {
			endX.current = e.changedTouches[0].clientX;
			const diffX = endX.current - startX.current;

			// const isMobileOrTab = deviceWidth <= 1200;
			const isMobileOrTab = false;

			if (isMobileOrTab && diffX < -80) {
				// setAsideStatus(false);
			}
		}

		if (asideStatus) {
			document.addEventListener('touchstart', handleTouchStart);
			document.addEventListener('touchend', handleTouchEnd);
		}

		return () => {
			document.removeEventListener('touchstart', handleTouchStart);
			document.removeEventListener('touchend', handleTouchEnd);
		};
	}, [asideStatus]);

	return (
		<>
			<motion.aside
				style={asideStyle}
				ref={constraintsRef}
				initial={{ x: '-100%' }}
				animate={{ x: true ? 0 : '-100%' }}
				// animate={{ x: asideStatus ? 0 : '-100%' }}
				transition={{ duration: 0.1, ease: 'easeInOut' }}
				className={classNames(
					'aside',
					{ open: true }, 
					// { open: asideStatus },
					{
						'aside-touch-bar': true,
						'aside-touch-bar-close':  true,
						'aside-touch-bar-open':   true,
						// 'aside-touch-bar': hasTouchButton && isModernDesign,
						// 'aside-touch-bar-close': !touchStatus && hasTouchButton && isModernDesign,
						// 'aside-touch-bar-open': touchStatus && hasTouchButton && isModernDesign,
					},
				)}>
				<div className='aside-head'>
					<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
				</div>
				<div className='aside-body'>
					<Navigation
						menu={dashboardMenu}
						id='aside-dashboard'
						asideStatus={asideStatus}
						setAsideStatus={setAsideStatus}
					/>
					{!doc && (
						<>
							<NavigationLine />
							<Navigation
								menu={admincontroll(demoPages, token?.is_super_admin)}
								id='aside-demo-pages'
								asideStatus={asideStatus}
								setAsideStatus={setAsideStatus}
							/>
							<NavigationLine />
						</>
					)}

					{doc && (
						<>
							<NavigationLine />
							<Navigation
								menu={componentsMenu}
								id='aside-menu-two'
								asideStatus={asideStatus}
								setAsideStatus={setAsideStatus}
							/>
							<NavigationLine />
						</>
					)}

					{asideStatus && doc && (
						<Card className='m-3 '>
							<CardBody className='pt-0'>
								<img
									srcSet={HandWebp}
									src={Hand}
									alt='Hand'
									width={130}
									height={130}
								/>
								<p
									className={classNames('h4', {
										'text-dark': !darkModeStatus,
										'text-light': darkModeStatus,
									})}>
									{'Everything is ready!'}
								</p>
								<Button
									color='info'
									isLight
									className='w-100'
									onClick={() => setDoc(false)}>
									{'Demo Pages'}
								</Button>
							</CardBody>
						</Card>
					)}
				</div>
				{/* <div className='aside-foot'>
					<nav aria-label='aside-bottom-menu'>
						<div className='navigation'>
							<div
								role='presentation'
								className='navigation-item cursor-pointer'
								onClick={() => {
									setDoc(!doc);
								}}
								data-tour='documentation'>
								<span className='navigation-link navigation-link-pill'>
									<span className='navigation-link-info'>
										<Icon
											icon={doc ? 'ToggleOn' : 'ToggleOff'}
											color={doc ? 'success' : null}
											className='navigation-icon'
										/>
										<span className='navigation-text'>
											{'menu:Documentation'}
										</span>
									</span>
								</span>
							</div>
						</div>
					</nav>
					<User />
				</div> */}
			</motion.aside>
			{/* {asideStatus && hasTouchButton && isModernDesign && (
				<>
					<motion.div className='aside-drag-area' ref={constraintsRef} />
					<Tooltips title='Toggle Aside' flip={['top', 'right']}>
						<motion.div
							className=''
							drag='x'
							whileDrag={{ scale: 1.2 }}
							whileHover={{ scale: 1.1 }}
							dragConstraints={constraintsRef}
							// onDrag={(event, info) => }
							dragElastic={0.1}
							style={{ x, zIndex: 1039 }}
							onClick={() => x.set(x.get() === 0 ? asideWidthWithSpace : 0)}
						/>
					</Tooltips>
				</>
			)} */}
		</>
	);
};

export default Aside;
